import { useQuery } from "convex/react";
import { api } from "../../../convex/_generated/api";
import type { Id } from "../../../convex/_generated/dataModel";
import { type QueryState, wrapQuery } from "../queryState";
import type { RepositoryHomeVM, RepositoryVM } from "../types/repository";
import { useSubscriptionActive } from "../components/SubscriptionScope";

/**
 * useRepositoryHome — wraps repositoryHome composite (PRD Section 8)
 */
export function useRepositoryHome(
  repositoryId: Id<"repositories">
): QueryState<RepositoryHomeVM> {
  const active = useSubscriptionActive();
  const raw = useQuery(
    api.composites.repositoryHome.repositoryHome,
    active ? { repositoryId } : "skip"
  );
  return wrapQuery(raw, (r) => r as RepositoryHomeVM);
}

/**
 * useRepositoryList — wraps api.repositories.list (PRD Section 8)
 */
export function useRepositoryList(): QueryState<RepositoryVM[]> {
  const active = useSubscriptionActive();
  const raw = useQuery(api.repositories.list, active ? {} : "skip");
  return wrapQuery(raw, (repos) =>
    repos.map((r) => ({
      id: r._id,
      name: r.name,
      slug: r.slug,
      repoPath: r.repoPath,
      githubRepoPath: r.githubRepoPath,
    }))
  );
}
